module.exports = __webpack_public_path__ + "static/cow-2293e58775b4eaef58735e86cccc794e.mp3";